import React from 'react'
import ReactDOM from 'react-dom'

import RegionChooser from '../RegionChooser'
import { choose, getBrowserLanguages } from '../RegionChooser/helpers'
import { useRegion } from '../RegionChooser/hook'

const RegionChooserWrapper = () => {
  const {
    ready,
    allRegions,
    geoCountryCode,
    shipToCountryCode,
    regionChooserDismissed,
    path,
  } = useRegion()

  if (!ready) {
    return null
  }

  if (window.location.pathname === '/' && path !== window.location.pathname) {
    window.location.pathname = path
    return null
  }

  if (regionChooserDismissed) {
    return null
  }

  const choice = choose(
    allRegions,
    window.location.pathname,
    geoCountryCode,
    getBrowserLanguages()
  )

  const choiceIsDifferent = choice.defaultTo !== shipToCountryCode

  if (choice.showChooser && choiceIsDifferent) {
    return <RegionChooser isOpen={true} onClose={() => {}} />
  }

  return null
}

export default (element: Element) => {
  return ReactDOM.render(<RegionChooserWrapper />, element)
}
